import { Avatar, Stack, Typography } from '@mui/material';
import { DICTIONARY } from 'Enum';
import { Dictionary } from 'Dictionary';
import { useIsDesktop } from 'Hooks';
import { PersonalTeamLogo } from 'Images';

export const PersonalTeamTitle = () => {
  const isDesktop = useIsDesktop();

  return (
    <Stack
      direction={isDesktop ? 'row' : 'column'}
      alignItems={'center'}
      gap={'20px'}
    >
      <Avatar
        alt={Dictionary[DICTIONARY.PersonalTeam].title}
        src={PersonalTeamLogo}
        sx={{ width: '50px', height: '50px' }}
      />
      <Typography variant={'h2'} color={'text.secondary'}>
        {Dictionary[DICTIONARY.PersonalTeam].title}
      </Typography>
    </Stack>
  );
};
